import EN from "../../locales/en";
import DisclosureSection from "./partials/DisclosureSection";
import RadioField from "./partials/RadioField";

const FasterSwitching = ({ isSubmitting }) => (
  <div className="mt-8 border-t border-[#afb6b9]">
    <h2 className="text-[30px] font-bold text-primary mt-6">
      {EN.switch.faster_switching.title}
    </h2>
    <p className="text-md leading-[1.5] mt-2">
      {EN.switch.faster_switching.description}
    </p>
    <h3 className="text-[22px] font-bold mt-6">
      {EN.switch.faster_switching.subtitle}
    </h3>
    <RadioField
      name="customerInfo.switchType"
      label={
        <>
          <p className="font-semibold">
            {EN.switch.faster_switching.yes_label}
          </p>
          <p className="mt-2">{EN.switch.faster_switching.yes_description}</p>
        </>
      }
      value="fasterSwitching"
      hideErrorMessage={true}
      disabled={isSubmitting}
    />
    <RadioField
      name="customerInfo.switchType"
      label={
        <>
          <p className="font-semibold">{EN.switch.faster_switching.no_label}</p>
          <p className="mt-2">{EN.switch.faster_switching.no_description}</p>
        </>
      }
      value="regular"
      disabled={isSubmitting}
    />

    <DisclosureSection
      title={EN.switch.faster_switching.cooling_off_disclosure_title}
      content={
        <div className="space-y-4">
          <p>{EN.switch.faster_switching.cooling_off_disclosure_content}</p>
        </div>
      }
    />
  </div>
);

export default FasterSwitching;
